import { Routes, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import {
  permissionGuard,
  moduleGuard,
  redirectToMovimientosTab,
  redirectToCatalogosTab,
  redirectToConfiguracionTab,
  redirectToEspacioTab
} from './guards/permission.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/redirect',
    pathMatch: 'full'
  },
  {
    path: 'redirect',
    canActivate: [authGuard],
    loadComponent: () => import('./components/redirect/redirect.component').then(m => m.RedirectComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { modules: ['dashboard', 'cierre', 'fiscal'] },
    loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'espacio',
    canActivate: [authGuard],
    loadComponent: () => import('./components/espacio/espacio-hub/espacio-hub.component').then(m => m.EspacioHubComponent)
  },
  {
    path: 'feed',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToEspacioTab('actividad')],
    loadComponent: () => import('./components/espacio/espacio-hub/espacio-hub.component').then(m => m.EspacioHubComponent)
  },
  {
    path: 'torre',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToEspacioTab('torre')],
    loadComponent: () => import('./components/espacio/espacio-hub/espacio-hub.component').then(m => m.EspacioHubComponent)
  },
  {
    path: 'movimientos',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { modules: ['movimientos', 'facturas', 'recurrentes'] },
    loadComponent: () => import('./components/movimientos/movimientos-list/movimientos-list.component').then(m => m.MovimientosListComponent)
  },
  {
    path: 'movimientos-pendientes',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToMovimientosTab('co')],
    loadComponent: () => import('./components/movimientos/movimientos-list/movimientos-list.component').then(m => m.MovimientosListComponent)
  },
  {
    path: 'movimientos/nuevo-egreso',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'create_egreso' } },
    loadComponent: () => import('./components/movimientos/nuevo-egreso/nuevo-egreso.component').then(m => m.NuevoEgresoComponent)
  },
  {
    path: 'movimientos/nuevo-ingreso',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'create_ingreso' } },
    loadComponent: () => import('./components/movimientos/nuevo-ingreso/nuevo-ingreso.component').then(m => m.NuevoIngresoComponent)
  },
  {
    path: 'movimientos/nuevo-traspaso',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'create_traspaso' } },
    loadComponent: () => import('./components/movimientos/nuevo-traspaso/nuevo-traspaso.component').then(m => m.NuevoTraspasoComponent)
  },
  {
    path: 'movimientos/nuevo-pago-nomina',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'create_pago_nomina' } },
    loadComponent: () => import('./components/movimientos/nuevo-pago-nomina/nuevo-pago-nomina.component').then(m => m.NuevoPagoNominaComponent)
  },
  {
    path: 'movimientos/nuevo-pago-creditos',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'create_pago_creditos' } },
    loadComponent: () => import('./components/movimientos/nuevo-pago-creditos/nuevo-pago-creditos.component').then(m => m.NuevoPagoCreditosComponent)
  },
  {
    path: 'movimientos/nuevo-fondeo',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'create_fondeo' } },
    loadComponent: () => import('./components/movimientos/nuevo-fondeo/nuevo-fondeo.component').then(m => m.NuevoFondeoComponent)
  },
  {
    path: 'movimientos/recurrentes/nuevo',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'recurrentes', accion: 'create' } },
    loadComponent: () => import('./components/movimientos/recurrente-form/recurrente-form.component').then(m => m.RecurrenteFormComponent)
  },
  {
    path: 'movimientos/recurrentes/:id/editar',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'recurrentes', accion: 'update' } },
    loadComponent: () => import('./components/movimientos/recurrente-form/recurrente-form.component').then(m => m.RecurrenteFormComponent)
  },
  {
    path: 'movimientos/:id',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { module: 'movimientos' },
    loadComponent: () => import('./components/movimientos/detalle-movimiento/detalle-movimiento.component').then(m => m.DetalleMovimientoComponent)
  },
  {
    path: 'movimientos/:id/editar',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'update' } },
    loadComponent: () => import('./components/movimientos/editar-movimiento/editar-movimiento.component').then(m => m.EditarMovimientoComponent)
  },
  {
    path: 'movimientos/:id/editar-egreso',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'update' } },
    loadComponent: () => import('./components/movimientos/editar-egreso/editar-egreso.component').then(m => m.EditarEgresoComponent)
  },
  {
    path: 'movimientos/:id/editar-ingreso',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'update' } },
    loadComponent: () => import('./components/movimientos/editar-ingreso/editar-ingreso.component').then(m => m.EditarIngresoComponent)
  },
  {
    path: 'movimientos/:id/editar-traspaso',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'update' } },
    loadComponent: () => import('./components/movimientos/editar-traspaso/editar-traspaso.component').then(m => m.EditarTraspasoComponent)
  },
  {
    path: 'movimientos/:id/editar-pago-nomina',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'update' } },
    loadComponent: () => import('./components/movimientos/editar-pago-nomina/editar-pago-nomina.component').then(m => m.EditarPagoNominaComponent)
  },
  {
    path: 'movimientos/:id/editar-pago-creditos',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'update' } },
    loadComponent: () => import('./components/movimientos/editar-pago-creditos/editar-pago-creditos.component').then(m => m.EditarPagoCreditosComponent)
  },
  {
    path: 'movimientos/:id/editar-fondeo',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'movimientos', accion: 'update' } },
    loadComponent: () => import('./components/movimientos/editar-fondeo/editar-fondeo.component').then(m => m.EditarFondeoComponent)
  },
  {
    path: 'facturas',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToMovimientosTab('fac')],
    loadComponent: () => import('./components/movimientos/movimientos-list/movimientos-list.component').then(m => m.MovimientosListComponent)
  },
  {
    path: 'facturas/:id/cargar',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'facturas', accion: 'update' } },
    loadComponent: () => import('./components/facturas/cargar-factura/cargar-factura.component').then(m => m.CargarFacturaComponent)
  },
  {
    path: 'factura',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { module: 'factura' },
    loadComponent: () => import('./components/factura-catalogo/factura-catalogo-list/factura-catalogo-list.component').then(m => m.FacturaCatalogoListComponent)
  },
  {
    path: 'factura/:id',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { module: 'factura' },
    loadComponent: () => import('./components/factura-catalogo/detalle-factura-catalogo/detalle-factura-catalogo.component').then(m => m.DetalleFacturaCatalogoComponent)
  },
  {
    path: 'catalogos',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { modules: ['clientes', 'proveedores', 'vehiculos'] },
    loadComponent: () => import('./components/catalogos/catalogos-hub/catalogos-hub.component').then(m => m.CatalogosHubComponent)
  },
  {
    path: 'configuracion',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { modules: ['usuarios', 'sat', 'sistema'] },
    loadComponent: () => import('./components/configuracion/configuracion-hub/configuracion-hub.component').then(m => m.ConfiguracionHubComponent)
  },
  {
    path: 'proveedores',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToCatalogosTab('proveedores')],
    loadComponent: () => import('./components/catalogos/catalogos-hub/catalogos-hub.component').then(m => m.CatalogosHubComponent)
  },
  {
    path: 'proveedores/nuevo',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'proveedores', accion: 'create' } },
    loadComponent: () => import('./components/proveedores/nuevo-proveedor/nuevo-proveedor.component').then(m => m.NuevoProveedorComponent)
  },
  {
    path: 'proveedores/:id',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { module: 'proveedores' },
    loadComponent: () => import('./components/proveedores/detalle-proveedor/detalle-proveedor.component').then(m => m.DetalleProveedorComponent)
  },
  {
    path: 'proveedores/:id/editar',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'proveedores', accion: 'update' } },
    loadComponent: () => import('./components/proveedores/editar-proveedor/editar-proveedor.component').then(m => m.EditarProveedorComponent)
  },
  {
    path: 'cuentas',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { module: 'cuentas' },
    loadComponent: () => import('./components/cuentas/cuentas-list/cuentas-list.component').then(m => m.CuentasListComponent)
  },
  {
    path: 'cuentas/nueva',
    canActivate: [authGuard],
    loadComponent: () => import('./components/cuentas/nueva-cuenta/nueva-cuenta.component').then(m => m.NuevaCuentaComponent)
  },
  {
    path: 'cuentas/:id',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { module: 'cuentas' },
    loadComponent: () => import('./components/cuentas/detalle-cuenta/detalle-cuenta.component').then(m => m.DetalleCuentaComponent)
  },
  {
    path: 'cuentas/:id/editar',
    canActivate: [authGuard],
    loadComponent: () => import('./components/cuentas/editar-cuenta/editar-cuenta.component').then(m => m.EditarCuentaComponent)
  },
  {
    path: 'cuentas/:cuentaId/permisos/:colaboradorId',
    canActivate: [authGuard],
    loadComponent: () => import('./components/cuentas/permisos-cuenta/permisos-cuenta.component').then(m => m.PermisosCuentaComponent)
  },
  {
    path: 'usuarios',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToConfiguracionTab('usuarios')],
    loadComponent: () => import('./components/configuracion/configuracion-hub/configuracion-hub.component').then(m => m.ConfiguracionHubComponent)
  },
  {
    path: 'usuarios/nuevo',
    canActivate: [authGuard],
    loadComponent: () => import('./components/usuarios/nuevo-usuario/nuevo-usuario.component').then(m => m.NuevoUsuarioComponent)
  },
  {
    path: 'usuarios/:id',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { module: 'usuarios' },
    loadComponent: () => import('./components/usuarios/detalle-usuario/detalle-usuario.component').then(m => m.DetalleUsuarioComponent)
  },
  {
    path: 'usuarios/:id/editar',
    canActivate: [authGuard],
    loadComponent: () => import('./components/usuarios/editar-usuario/editar-usuario.component').then(m => m.EditarUsuarioComponent)
  },
  {
    path: 'usuarios/:id/permisos',
    canActivate: [authGuard],
    loadComponent: () => import('./components/usuarios/permisos-usuario/permisos-usuario.component').then(m => m.PermisosUsuarioComponent)
  },
  {
    path: 'usuarios/:colaboradorId/cuenta/:cuentaId/permisos',
    canActivate: [authGuard],
    loadComponent: () => import('./components/cuentas/permisos-cuenta/permisos-cuenta.component').then(m => m.PermisosCuentaComponent)
  },
  {
    path: 'perfil',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToEspacioTab('perfil')],
    loadComponent: () => import('./components/espacio/espacio-hub/espacio-hub.component').then(m => m.EspacioHubComponent)
  },
  {
    path: 'vehiculos',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToCatalogosTab('vehiculos')],
    loadComponent: () => import('./components/catalogos/catalogos-hub/catalogos-hub.component').then(m => m.CatalogosHubComponent)
  },
  {
    path: 'vehiculos/nuevo',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'vehiculos', accion: 'create' } },
    loadComponent: () => import('./components/vehiculos/nuevo-vehiculo/nuevo-vehiculo.component').then(m => m.NuevoVehiculoComponent)
  },
  {
    path: 'vehiculos/:id',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { module: 'vehiculos' },
    loadComponent: () => import('./components/vehiculos/detalle-vehiculo/detalle-vehiculo.component').then(m => m.DetalleVehiculoComponent)
  },
  {
    path: 'vehiculos/:id/editar',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'vehiculos', accion: 'update' } },
    loadComponent: () => import('./components/vehiculos/editar-vehiculo/editar-vehiculo.component').then(m => m.EditarVehiculoComponent)
  },
  {
    path: 'clientes',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToCatalogosTab('clientes')],
    loadComponent: () => import('./components/catalogos/catalogos-hub/catalogos-hub.component').then(m => m.CatalogosHubComponent)
  },
  {
    path: 'clientes/nuevo',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'clientes', accion: 'create' } },
    loadComponent: () => import('./components/clientes/nuevo-cliente/nuevo-cliente.component').then(m => m.NuevoClienteComponent)
  },
  {
    path: 'clientes/:id',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => moduleGuard(route, state)],
    data: { module: 'clientes' },
    loadComponent: () => import('./components/clientes/detalle-cliente/detalle-cliente.component').then(m => m.DetalleClienteComponent)
  },
  {
    path: 'clientes/:id/editar',
    canActivate: [authGuard, (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => permissionGuard(route, state)],
    data: { permission: { modulo: 'clientes', accion: 'update' } },
    loadComponent: () => import('./components/clientes/editar-cliente/editar-cliente.component').then(m => m.EditarClienteComponent)
  },
  {
    path: 'sat',
    pathMatch: 'full',
    canActivate: [authGuard, redirectToConfiguracionTab('sat')],
    loadComponent: () => import('./components/configuracion/configuracion-hub/configuracion-hub.component').then(m => m.ConfiguracionHubComponent)
  }
];
